import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import {MatRadioModule} from '@angular/material/radio';
import {MatListModule} from '@angular/material/list';
import {MatSelectModule} from '@angular/material/select';
import {MatExpansionModule} from '@angular/material/expansion';
import {MatSidenavModule} from '@angular/material/sidenav';
import {MatIconModule} from '@angular/material/icon';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatToolbarModule} from '@angular/material/toolbar';
import {MatButtonModule} from '@angular/material/button';
import {MatInputModule} from '@angular/material/input';
import {TextFieldModule} from '@angular/cdk/text-field';
import {MatGridListModule} from '@angular/material/grid-list';
import {MatNativeDateModule} from '@angular/material/core';
import {MatLineModule} from '@angular/material/core';
import {GoogleMapsModule} from '@angular/google-maps';
import {MatCardModule} from '@angular/material/card';
import {MatButtonToggleModule} from '@angular/material/button-toggle';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatDividerModule} from '@angular/material/divider';
import {MatTabsModule} from '@angular/material/tabs';
import {MAT_CHIPS_DEFAULT_OPTIONS, MatChipsModule} from '@angular/material/chips';
import {} from '@angular/common/http';
import {MatDialogModule} from '@angular/material/dialog';
import {MatTooltipModule} from '@angular/material/tooltip';
import {AlertDialogComponent} from './components/alert-dialog/alert-dialog.component';
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import {MatSnackBarModule} from '@angular/material/snack-bar';
import { MatSliderModule } from '@angular/material/slider';
import {SnackBarComponent} from './components/snack-bar/snack-bar.component';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {NgxMatDatetimePickerModule, NgxMatNativeDateModule, NgxMatTimepickerModule} from '@angular-material-components/datetime-picker';
import { AttachmentPickerComponent } from './components/attachment-picker/attachment-picker.component';
import { TerminateJobSharedComponent } from './components/terminate-job-shared/terminate-job-shared.component';
import { AssignSupervisorComponent } from './components/assign-supervisor/assign-supervisor.component';
import {PaymentTermsComponent} from '@shared/components/payment-terms/payment-terms.component';
import {MatMenuModule} from '@angular/material/menu';
import { ContainerNumberComponent } from './components/container-number/container-number.component';
import { MultiSelectDropDownComponent } from './components/multi-select-drop-down/multi-select-drop-down.component';
import { LabelChipComponent } from './components/label-chip/label-chip.component';
import { LabelFilterSelectComponent } from './components/label-filter-select/label-filter-select.component';
import {COMMA, ENTER} from '@angular/cdk/keycodes';
import { MinutesToHoursMinutesPipe } from './pipes/minutes-to-hours-minutes.pipe';
import {MapComponent} from '@shared/components/map/map.component';
import { MapLocationSearchComponent } from './components/map-location-search/map-location-search.component';
import { MapDrawGeoFenceComponent } from './components/map-draw-geo-fence/map-draw-geo-fence.component';
import {ImageAttachmentWizardComponent} from '@shared/components/image-attachment-wizard/image-attachment-wizard.component';
import {MatTreeModule} from '@angular/material/tree';
import {DynamicComponentDirective} from '@shared/directives/dynamic-component.directive';
import {DatetimePickerDefaultTimeDirective} from '@shared/directives/datetime-picker-default-time.directive';
import { RegisteredAddressComponent } from './components/registered-address/registered-address.component';
import { ContactNumbersComponent } from './components/contact-numbers/contact-numbers.component';
import { PrincipleContactsComponent } from './components/principle-contacts/principle-contacts.component';
import { ContactDetailsComponent } from './components/contact-details/contact-details.component';
import { ContactViewComponent } from './components/contact-view/contact-view.component';
import {LiveMapLegendComponent} from './components/live-map-legend/live-map-legend.component';
import {LiveMapVehicleDetailsComponent} from '@shared/components/live-map-vehicle-details/live-map-vehicle-details.component';
import {AuthorizePipe} from '@shared/pipes/authorize.pipe';
import { AppAutoTabDirective } from './directives/app-auto-tab.directive';
import { MapJpmComponent } from './components/map-jpm/map-jpm.component';
import { AddContainerBulkComponent } from './components/add-container-bulk/add-container-bulk.component';
import {ClickOutsideDirective} from '@shared/directives/click-outside.directive';
import { ResourcesDetailsComponent } from './components/resources-details/resources-details.component';
import { ResourceViewComponent } from './components/resource-view/resource-view.component';
import {JobImformationComponent} from '@shared/components/job-imformation/job-imformation.component';
import { NotificationComponent } from './components/notification/notification.component';
import {DocumentRefTypePipe} from '@shared/pipes/document-ref-type.pipe';
import { MatPaginatorModule } from '@angular/material/paginator';
import { JobListComponent } from './components/job-list/job-list.component';
import { CreateJobFileComponent } from './components/create-job-file/create-job-file.component';
import { AddCollaboratorsComponent } from './components/add-collaborators/add-collaborators.component';
import { SelectBehalfOrganizationComponent } from './components/select-behalf-organization/select-behalf-organization.component';
import { InvoiceChatPanelComponent } from '../modules/invoice/components/invoice-chat-panel/invoice-chat-panel.component';
import { InvoiceProgressLineComponent } from '../modules/invoice/pages/invoice-progress-line/invoice-progress-line.component';
import { ProgressLineComponent } from './components/progress-line/progress-line.component';
import { ProgressTabLineComponent } from './components/progress-tab-line/progress-tab-line.component';
import { ShipmentOrderComponent } from './components/shipment-order/shipment-order.component';
import { ShipmentOrderSpecsComponent } from './components/shipment-order-specs/shipment-order-specs.component';
import { OrderRowComponent } from './components/shipment-order-specs/order-row/order-row.component';
import { OrderListComponent } from './components/order-list/order-list.component';
import { MatTableModule } from '@angular/material/table';
import { MatSortModule } from '@angular/material/sort';
import { NumberToTextPipe } from './pipes/number-to-text.pipe';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { TimeFormatPipe } from './pipes/time-format.pipe';
import { ZeroPadPipe } from './pipes/zero-pad.pipe';
import { DocumentAttachmentWizardComponent } from './components/document-attachment-wizard/document-attachment-wizard.component';
import { TooltipListPipe } from './pipes/tool-tip-list.pipe';
import { RestrictDecimalPlacesDirective } from './directives/restrict-number-input-directive';
import { MapGeoFenceSpeedComponent } from './components/map-geo-fence-speed/map-geo-fence-speed.component';
import { DistanceMatrixComponent } from './components/distance-matrix/distance-matrix.component';
import { ValidationMessageComponent } from './components/validation-message/validation-message.component';
import { FlagDownRateComponent } from './components/flag-down-rate/flag-down-rate.component';
import { DateTimeFilterBarComponent } from './components/date-time-filter-bar/date-time-filter-bar.component';
import { SkeletonLoaderComponent } from './components/skeleton-loader/skeleton-loader.component';
import { JobLoadListComponent } from './components/job-load-list/job-load-list.component';
import { NavigationHandlerDirective } from './directives/navigation-handler.directive';
import { LoadingOverlayComponent } from './components/loading-overlay/loading-overlay.component';
import { ButtonLoadingDirective } from './directives/button-loading.directive';
import { LocationRatesDialogComponent } from './components/location-rates-dialog/location-rates-dialog.component';
import { LocationBasedRatesComponent } from './components/location-based-rates/location-based-rates.component';
import { DownloadDialogComponent } from './components/download-dialog/download-dialog.component';
import { CustomDateRangePickerComponent } from './components/custom-date-range-picker/custom-date-range-picker.component';
import {CapacityWarningDialogComponent} from '@shared/components/capacity-warning-dialog/capacity-warning-dialog.component';
import { CustomDatePickerComponent } from './components/custom-date-picker/custom-date-picker.component';
import { DateRangeDialogComponent } from './components/date-range-dialog/date-range-dialog.component';
import { CustomPaginationComponent } from './components/custom-pagination/custom-pagination.component';
import { RelativeDateSelectorComponent } from './components/relative-date-selector/relative-date-selector.component';
import { BulkUploadResultComponent } from '../modules/organization/components/bulk-upload-result/bulk-upload-result.component';
import { JobDetailsHeaderComponent } from './components/job-details-header/job-details-header.component';
import { JobPlanningFooterBarComponent } from './components/job-planning-footer-bar/job-planning-footer-bar.component';
import { JobPlanOrderListComponent } from './components/job-plan-order-list/job-plan-order-list.component';
import { JobPlanOrderDisplayComponent } from './components/job-plan-order-display/job-plan-order-display.component';
import { JobPlanOrderListItemsComponent } from './components/job-plan-order-list-items/job-plan-order-list-items.component';
import { RateBlockSelectComponent } from './components/rate-block-select/rate-block-select.component';
import { ConfirmationDialogComponent } from './components/confirmation-dialog/confirmation-dialog.component';
import { OptimizationProgressDialogComponent } from './components/optimization-progress-dialog/optimization-progress-dialog.component';
import { OptimizationAnimationDialogComponent } from './components/optimization-animation-dialog/optimization-animation-dialog.component';
import { DocumentsDialogComponent } from './components/documents-dialog/documents-dialog.component';
import { ColloboraterSettingsComponent } from './components/colloborater-settings/colloborater-settings.component';
import { AdvancedTextAreaComponent } from './components/advanced-text-area/advanced-text-area.component';
import { BookingEngineOverlayComponent } from './components/booking-engine-overlay/booking-engine-overlay.component';
import { BookingEngineCardComponent } from './components/booking-engine-card/booking-engine-card.component';
import { InviteCollaboratorsComponent } from './components/invite-collaborators/invite-collaborators.component';
import { StandardVehicleComponentV2 } from './components/standard-vehicle-v2/standard-vehicle.component';
import { CustomDropdownComponent } from './components/custom-dropdown/custom-dropdown.component';
import { RouteMapDialogComponent } from './components/route-map-dialog-component/route-map-dialog-component.component';
import { OrderFiltersComponent } from './components/order-filters/order-filters.component';
import { JobPlanWindowCardsComponent } from './components/job-plan-window-cards/job-plan-window-cards.component';
import { JobPlanOrderDetailsComponent } from './components/job-plan-order-details/job-plan-order-details.component';
import { JobPlanOrderRowComponent } from './components/job-plan-order-row/job-plan-order-row.component';
import { JobPlanOrderHeaderComponent } from './components/job-plan-order-header/job-plan-order-header.component';
import { JobPlanOrderSortingComponent } from './components/job-plan-order-sorting/job-plan-order-sorting.component';
import { HmtFirstClassOrgFilterComponent } from './components/hmt-first-class-org-filter/hmt-first-class-org-filter.component';
import { AssignNotifyConfirmationDialogComponent } from './components/assign-notify-confirmation-dialog/assign-notify-confirmation-dialog.component';
import { OrderListPopup } from '../modules/dynamic-form/components/order-list-result/order-list-result.compoent';
// do not import any service here, because it will create multiple service instances unless it is acceptable
// do not import this to app module
// do import this module in any other feature module

@NgModule({
  declarations: [
    AlertDialogComponent,
    SnackBarComponent,
    NotificationComponent,
    AttachmentPickerComponent,
    TerminateJobSharedComponent,
    PaymentTermsComponent,
    AssignSupervisorComponent,
    ContainerNumberComponent,
    MapComponent,
    LiveMapLegendComponent,
    LiveMapVehicleDetailsComponent,
    MultiSelectDropDownComponent,
    LabelChipComponent,
    LabelFilterSelectComponent,
    MinutesToHoursMinutesPipe,
    MinutesToHoursMinutesPipe,
    ContainerNumberComponent,
    MapComponent,
    ContainerNumberComponent,
    MapLocationSearchComponent,
    MapDrawGeoFenceComponent,
    ImageAttachmentWizardComponent,
    MapDrawGeoFenceComponent,
    DynamicComponentDirective,
    DatetimePickerDefaultTimeDirective,
    RegisteredAddressComponent,
    ContactNumbersComponent,
    PrincipleContactsComponent,
    ContactDetailsComponent,
    ContactViewComponent,
    AuthorizePipe,
    DocumentRefTypePipe,
    AppAutoTabDirective,
    MapJpmComponent,
    AddContainerBulkComponent,
    JobImformationComponent,
    ResourcesDetailsComponent,
    ResourceViewComponent,
    JobListComponent,
    JobLoadListComponent,
    CreateJobFileComponent,
    AddCollaboratorsComponent,
    SelectBehalfOrganizationComponent,
    InvoiceProgressLineComponent,
    InvoiceChatPanelComponent,
    ProgressLineComponent,
    ProgressTabLineComponent,
    ShipmentOrderComponent,
    ShipmentOrderSpecsComponent,
    OrderRowComponent,
    OrderListComponent,
    ConfirmationDialogComponent,
    RateBlockSelectComponent,
    NumberToTextPipe,
    TimeFormatPipe,
    ZeroPadPipe,
    DocumentAttachmentWizardComponent,
    TooltipListPipe,
    RestrictDecimalPlacesDirective,
    MapGeoFenceSpeedComponent,
    DistanceMatrixComponent,
    ValidationMessageComponent,
    FlagDownRateComponent,
    DateTimeFilterBarComponent,
    SkeletonLoaderComponent,
    JobLoadListComponent,
    NavigationHandlerDirective,
    LoadingOverlayComponent,
    ButtonLoadingDirective,
    LocationRatesDialogComponent,
    LocationBasedRatesComponent,
    DownloadDialogComponent,
    CapacityWarningDialogComponent,
    CustomDateRangePickerComponent,
    DateRangeDialogComponent,
    CustomDatePickerComponent,
    CustomPaginationComponent,
    RelativeDateSelectorComponent,
    BulkUploadResultComponent,
    JobDetailsHeaderComponent,
    JobPlanningFooterBarComponent,
    JobPlanOrderListComponent,
    JobPlanOrderDisplayComponent,
    JobPlanOrderListItemsComponent,
    OptimizationProgressDialogComponent,
    OptimizationAnimationDialogComponent,
    DocumentsDialogComponent,
    ColloboraterSettingsComponent,
    AdvancedTextAreaComponent,
    BookingEngineOverlayComponent,
    BookingEngineCardComponent,
    InviteCollaboratorsComponent,
    StandardVehicleComponentV2,
    CustomDropdownComponent,
    RouteMapDialogComponent,
    OrderFiltersComponent,
    JobPlanWindowCardsComponent,
    JobPlanOrderDetailsComponent,
    JobPlanOrderRowComponent,
    JobPlanOrderHeaderComponent,
    JobPlanOrderSortingComponent,
    AssignNotifyConfirmationDialogComponent,
    OrderListPopup
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    // HttpClientModule,
    MatToolbarModule,
    MatGridListModule,
    MatSlideToggleModule,
    MatSliderModule,
    MatCardModule,
    MatRadioModule,
    MatCheckboxModule,
    MatButtonModule,
    MatSelectModule,
    MatFormFieldModule,
    MatExpansionModule,
    MatSidenavModule,
    MatListModule,
    MatIconModule,
    MatNativeDateModule,
    MatLineModule,
    MatDatepickerModule,
    MatInputModule,
    TextFieldModule,
    GoogleMapsModule,
    MatButtonToggleModule,
    MatDividerModule,
    MatTabsModule,
    MatTableModule,
    MatDialogModule,
    MatTooltipModule,
    MatAutocompleteModule,
    MatSnackBarModule,
    MatProgressSpinnerModule,
    NgxMatDatetimePickerModule,
    NgxMatNativeDateModule,
    NgxMatTimepickerModule,
    MatMenuModule,
    MatChipsModule,
    MatTreeModule,
    MatPaginatorModule,
    MatSortModule,
    ScrollingModule,
    HmtFirstClassOrgFilterComponent
  ],
    exports: [
        // export any modules, components, pipes and etc.
        InvoiceChatPanelComponent,
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        // HttpClientModule,
        MatGridListModule,
        MatSlideToggleModule,
        MatSliderModule,
        MatCardModule,
        MatRadioModule,
        MatCheckboxModule,
        MatToolbarModule,
        MatButtonModule,
        MatSelectModule,
        MatFormFieldModule,
        MatExpansionModule,
        MatSidenavModule,
        MatListModule,
        GoogleMapsModule,
        MatNativeDateModule,
        MatLineModule,
        MatDatepickerModule,
        MatInputModule,
        TextFieldModule,
        MatIconModule,
        MatButtonToggleModule,
        MatDividerModule,
        MatTabsModule,
        MatChipsModule,
        MatDialogModule,
        MatTableModule,
        MatTooltipModule,
        MatAutocompleteModule,
        MatTreeModule,
        MatSnackBarModule,
        MatProgressSpinnerModule,
        NgxMatDatetimePickerModule,
        NgxMatNativeDateModule,
        NgxMatTimepickerModule,
        MatMenuModule,
        AttachmentPickerComponent,
        PaymentTermsComponent,
        ContainerNumberComponent,
        MultiSelectDropDownComponent,
        LabelChipComponent,
        LabelFilterSelectComponent,
        MapComponent,
        ImageAttachmentWizardComponent,
        DynamicComponentDirective,
        DatetimePickerDefaultTimeDirective,
        RegisteredAddressComponent,
        ContactNumbersComponent,
        PrincipleContactsComponent,
        ContactDetailsComponent,
        ContactViewComponent,
        MapLocationSearchComponent,
        MapDrawGeoFenceComponent,
        LiveMapLegendComponent,
        LiveMapVehicleDetailsComponent,
        AuthorizePipe,
        AppAutoTabDirective,
        MapJpmComponent,
        AddContainerBulkComponent,
        JobImformationComponent,
        ResourcesDetailsComponent,
        MinutesToHoursMinutesPipe,
        DocumentRefTypePipe,
        MatPaginatorModule,
        MatIconModule,
        MatMenuModule,
        MatFormFieldModule,
        MatInputModule,
        MatListModule,
        MatSortModule,
        JobListComponent,
        JobLoadListComponent,
        CreateJobFileComponent,
        MatPaginatorModule,
        ShipmentOrderComponent,
        ShipmentOrderSpecsComponent,
        OrderRowComponent,
        OrderListComponent,
        ConfirmationDialogComponent,
        RateBlockSelectComponent,
        ProgressLineComponent,
        ProgressTabLineComponent,
        DragDropModule,
        ScrollingModule,
        NumberToTextPipe,
        TimeFormatPipe,
        ZeroPadPipe,
        TooltipListPipe,
        DocumentAttachmentWizardComponent,
        RestrictDecimalPlacesDirective,
        MapGeoFenceSpeedComponent,
        FlagDownRateComponent,
        DateTimeFilterBarComponent,
        SkeletonLoaderComponent,
        NavigationHandlerDirective,
        LoadingOverlayComponent,
        ButtonLoadingDirective,
        LocationRatesDialogComponent,
        LocationBasedRatesComponent,
        DownloadDialogComponent,
        CapacityWarningDialogComponent,
        CustomDateRangePickerComponent,
        CustomDatePickerComponent,
        CustomPaginationComponent,
        RelativeDateSelectorComponent,
        JobDetailsHeaderComponent,
        JobPlanningFooterBarComponent,
        JobPlanOrderListComponent,
        JobPlanOrderDisplayComponent,
        JobPlanOrderListItemsComponent,
        ColloboraterSettingsComponent,
        AdvancedTextAreaComponent,
        BookingEngineOverlayComponent,
        BookingEngineCardComponent,
        InviteCollaboratorsComponent,
        StandardVehicleComponentV2,
        CustomDropdownComponent,
        RouteMapDialogComponent,
        JobPlanWindowCardsComponent,
        JobPlanOrderDetailsComponent,
        JobPlanOrderRowComponent,
        JobPlanOrderHeaderComponent,
        JobPlanOrderSortingComponent,
        HmtFirstClassOrgFilterComponent
    ],
    providers: [
      {
        provide: MAT_CHIPS_DEFAULT_OPTIONS,
        useValue: {
          separatorKeyCodes: [ENTER, COMMA]
        }
      }
    ]
})
export class SharedModule {
}
